"use client";

import PublicFooter from "@/components/layout/PublicFooter";
import PublicHeader from "@/components/layout/PublicHeader";

export default function PublicLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <PublicHeader />
      <main
        className="min-h-screen max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8"
        id="main-content"
        role="main"
        tabIndex={-1}
      >
        {children}
      </main>
      <PublicFooter />
    </>
  );
}
